import { Component, OnInit, AfterViewInit, ViewChildren, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControlName } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Login } from "./login";
import 'rxjs/add/operator/debounceTime';
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { GlobalService } from "../../global.service";
import { HeaderAndNavigationService } from '../headerandnavigation.service';
import { ILoggedUser } from '../loggeduser/loggeduser';
import { ForgottenPassword } from '../forgottenpassword/forgottenpassword';
import { GenericValidator } from '../../shared/generic-validator';
import { Observable } from 'rxjs/Observable';
import { LoaderService } from '../../LoaderService';
declare var $: any;

@Component({
  templateUrl: './impersonatelogin.component.html'
})
export class ImpersonateLoginComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  forgottenForm: FormGroup;
  forgotten: ForgottenPassword = new ForgottenPassword();
  displayMessageSendPassword: { [key: string]: string } = {};
  private validationMessagesSendPassword: { [key: string]: { [key: string]: string } };
  private genericValidatorSendPassword: GenericValidator;


  public pageTitle: string = 'Impersonate Login';
  loginForm: FormGroup;
  login: Login = new Login();
  errorMessage: string;
  public loading = false;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public globalService: GlobalService,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.validationMessagesSendPassword = {
      username: {
        required: 'username is required.'
      },
      impersonation_id: {
        required: 'impersonate user is required.'
      }
    };
    this.genericValidatorSendPassword = new GenericValidator(this.validationMessagesSendPassword);
  }

  ngOnInit(): void {
    //debugger;
    this.headerAndNavigationService.ClearUserData();
    this.appCommonService.pageContentAdditionalClass = "home-page login-page";
    // subscribe to router event
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let impersanateid = params['impersonationId'];
      this.loginForm = this.fb.group({
        username: ['', [Validators.required]],
        password: ['', [Validators.required]],
        impersonation_id: [impersanateid, [Validators.required]]
      });
      this.xRMImpersonateCall(impersanateid);
    });
    

    this.forgottenForm = this.fb.group({
      username: ['', [Validators.required]]
    });
  }

  xRMImpersonateCall(impersanateid) {
    localStorage.setItem(this.authService.mftImpersonationId, impersanateid);
    setTimeout(() => {
      this.authService.login();
    }, 1500);
  }

  logIn(): void {
    if (this.loginForm.dirty && this.loginForm.valid) {
      // Copy the form values over the product object values
      let p = Object.assign({}, this.login, this.loginForm.value);
      this.loaderService.display(true);
      this.authService.obtainAccessToken(p)
        .subscribe(
        (token: any) => {
          this.headerAndNavigationService.getLoggedUserFromAPI(token)
            .subscribe(
            (user: ILoggedUser) => {
              this.authService.setUser(user);
              this.authService.setUserRoles(user);
              this.authService.saveToken(token);
              this.onLoginComplete();
              this.loaderService.display(false);
              this.redirectToRelevantAccessArea();
            },
            (error: any) => {
              this.headerAndNavigationService.showError("Logged user retrieval problem", <any>error);
              this.loaderService.display(false);
              this.headerAndNavigationService.RedirectToLogin();
            }
            );
        },
        (error: any) => {
          this.loaderService.display(false);
          this.globalService.showError("Login", <any>error)
        }
        );
    } else if (!this.loginForm.dirty) {
      this.onLoginComplete();
    }
  }

  redirectToRelevantAccessArea(): void {
    if (this.appCommonService.reDirectURL === '/login') {
      this.appCommonService.reDirectURL = '/home';
    }
    this.router.navigate([this.appCommonService.reDirectURL]);
  }

  onLoginComplete(): void {
    // Reset the form to clear the flags
    this.loginForm.reset();
    this.errorMessage = '';
  }

  sendPasswordClick(): void {
    if (this.forgottenForm) {
      this.reSetSendPasswordForm();
    }
    $('#forgotpassModal').modal('show');
  }

  sendPasswordSubmit(): void {
    if (this.forgottenForm.valid) {
      let p = Object.assign({}, this.forgotten, this.forgottenForm.value);
      this.loaderService.display(true);
      this.headerAndNavigationService.sendUserPassword(p)
        .subscribe(
        () => {
          //$('#forgotpassModal').modal('hide');
          this.loaderService.display(false);
          this.reSetSendPasswordForm();
          this.globalService.showSuccess("", "Password reset link sent successfully to registered email address.", true);
        },
        (error: any) => {

          this.loaderService.display(false);
          this.globalService.showError("Password", <any>error, true);
        }
        );
    } else if (!this.forgottenForm.dirty) {
      this.reSetSendPasswordForm();
      $('#forgotpassModal').modal('hide');
    }
  }

  reSetSendPasswordForm() {
    this.forgottenForm.reset();
    this.globalService.msgs = [];
  }

  ngAfterViewInit() {
    //this.appCommonService.loadRequiredJS();
    //// Watch for the blur event from any input element on the form.
    //let controlBlurs: Observable<any>[] = this.formInputElements
    //  .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

    //// Merge the blur event observable with the valueChanges observable
    //Observable.merge(this.forgottenForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
    //  this.displayMessageSendPassword = this.genericValidatorSendPassword.processMessages(this.forgottenForm);
    //});
  }

  autoCompleteCall(event) {
    var passwordControl = document.getElementById("passwordId");
    passwordControl.removeAttribute("autocomplete");
    passwordControl.setAttribute("autocomplete", "off");
  }

  onSubmitClick() {
    if (this.loginForm.valid) {

    } else {
      Object.keys(this.loginForm.controls).forEach(field => {
        const control = this.loginForm.get(field);
        control.markAsDirty();
        control.updateValueAndValidity();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/login/impersonatelogin.component.ts